module.exports = __webpack_public_path__ + "static/media/credit_card-24px.4d597204.svg";